import { makeStyles } from '@material-ui/core'

import { lang } from '../../../../localization'

const useStyles = makeStyles((theme) => ({
  paperWeekly: {
    width: '100%',
    overflow: 'hidden',
    height: 70,
    backgroundColor: theme.palette.grey[200],
    boxShadow: 'none'
  },
  paperMonthly: {
    overflow: 'hidden',
    display: 'grid',
    gridTemplateColumns: '12fr repeat(31,1fr)',
    height: 70,
    marginBottom: 20
  },
  daysContainer: {
    width: '100%',
    height: '100%',
    display: 'grid',
    gridTemplateColumns: 'repeat(15,1fr)'
  },
  daysContainerForMonth: {
    gridTemplateColumns: 'repeat(32,1fr)'
  },
  dayContainer: {
    display: 'flex',
    flexDirection: 'column',
    justifyContent: 'center',
    alignItems: 'center',
    textAlign: 'center',
    fontSize: 14,
    color: 'gray',
    padding: 8,
    width: 100,
    height: 70,
    boxSizing: 'border-box',
    borderLeft: `1px solid ${
      theme.palette.type === 'dark' ? '#555' : '#e7e7e7'
    }`
  },
  dayContainerSmall: {
    fontSize: 12
  },
  arrowIcon: {
    transform: `rotate(${lang === 'fa' ? '180deg' : '0deg'})`
  },
  prevPageIcon: {
    transform: `rotate(${lang === 'fa' ? '0deg' : '180deg'})`
  },
  bigDateContainer: {
    display: 'flex',
    justifyContent: 'flex-end',
    alignItems: 'center'
  },
  bigDate: {
    width: 90,
    textAlign: 'center'
  },
  bidDateContainer: {
    position: 'relative'
  },
  datePickerContainer: {
    position: 'absolute',
    top: 32,
    zIndex: 1
  },
  weekendDayContainer: {
    backgroundColor:
      theme.palette.type === 'dark' ? `rgba(120, 132, 255,0.25)` : '#fff2f2'
  }
}))

export default useStyles
